import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const username = environment.auth.username;
  const password = environment.auth.passwd;

  // Encode credentials as Base64 for Basic Authentication
  const encodedCredentials = btoa(`${username}:${password}`);
  console.log(encodedCredentials)

  const newReq = req.clone({
    headers: req.headers.append('Authorization', `Basic ${encodedCredentials}`),
  });

  return next(newReq);
}
